import { Effect, PostProcess, ShaderMaterial, Vector2, Vector4 } from '@babylonjs/core';
import { Game } from './Game';

export class ShaderFactory {
  constructor(public game: Game) {}

  static defaultVertexShader = `
    attribute vec3 position;
    attribute vec3 normal;
    attribute vec2 uv;

    uniform mat4 worldViewProjection;
    uniform float time;

    varying vec3 vPosition;
    varying vec2 vUV;

    void main() {
        vec4 p = vec4( position, 1. );
        vPosition = p.xyz;
        vUV = uv;
      gl_Position = worldViewProjection * p;
    }
  `;

  async createPostProcessAsync(name: string, fragmentFileName?: string): Promise<PostProcess> {
    if (!fragmentFileName) {
      fragmentFileName = name;
    }
    const fragmentFile = 'assets/shaders/' + fragmentFileName + '.glsl';
    const fragment = await (await fetch(fragmentFile)).text();
    const postProcess = this.createPostProcess(name, fragment);
    return postProcess;
  }

  createPostProcess(name: string, fragment: string): PostProcess {
    Effect.ShadersStore[name + 'FragmentShader'] = fragment;

    const postProcess = new PostProcess('post_process_' + name, name, ['iTime', 'iResolution'], null, 1.0, this.game.scene.activeCamera);
    postProcess.samples = 1;
    let time = 0;

    postProcess.onApply = (effect) => {
      effect.setFloat2('iResolution', postProcess.width, postProcess.height);
      effect.setFloat('iTime', time);
      effect.setVector4('iMouse', Vector4.Zero());
    };

    postProcess.onBeforeRender = (effect) => {
      time += 0.01;
      effect.setFloat('iTime', time);
      effect.setVector4('iMouse', Vector4.Zero());
    };

    return postProcess;
  }

  async loadFragmentShader(name: string): Promise<string> {
    const fragmentFile = 'assets/shaders/' + name + '.glsl';
    const fragment = await (await fetch(fragmentFile)).text();
    return fragment;
  }

  createShaderMaterial(name: string, fragment: string, vertex: string = ShaderFactory.defaultVertexShader): ShaderMaterial {
    const shader = new ShaderMaterial(
      name,
      this.game.scene,
      {
        vertex: name,
        fragment: name,
      },
      {
        attributes: ['position', 'normal', 'uv'],
        uniforms: ['world', 'worldView', 'worldViewProjection', 'view', 'iTime', 'iResolution'],
      }
    );

    shader.setVector2('iResolution', new Vector2(1, 1));

    Effect.ShadersStore[name + 'FragmentShader'] = fragment;
    Effect.ShadersStore[name + 'VertexShader'] = vertex;

    let time = 0;
    this.game.scene.registerBeforeRender(() => {
      time += 0.01;
      shader.setFloat('iTime', time);
      const aRatio = this.game.scene.getEngine().getAspectRatio(this.game.scene.activeCamera);
      shader.setVector2('iResolution', new Vector2(aRatio, 1));
    });

    return shader;
  }
}
